import { render, staticRenderFns } from "./WorkedDetails.vue?vue&type=template&id=6c4dda96"
import script from "./WorkedDetails.vue?vue&type=script&lang=js"
export * from "./WorkedDetails.vue?vue&type=script&lang=js"
import style0 from "./WorkedDetails.vue?vue&type=style&index=0&id=6c4dda96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports